import React from "react";

const PartnersImage = ({partner}) => {
    return <a href={partner.href} className="partner" target="_blank" rel="noreferrer noopener">
        <img src={partner.image.publicURL} alt={partner.id}/>
    </a>
}

export default PartnersImage
